import React from "react";
import "./../Styles/policy.css";
export default function UsefulLink() {
  return (
    <div className="useful-links-page">
      <div className="useful-links-container">
        <h1 className="useful-links-title">Useful Tools</h1>

        <p className="useful-links-subtitle">
          Download the tools required for support and opening design files.
        </p>

        <ul className="download-list">
          <li className="download-item">
            <div className="download-left">
              <div className="download-icon">
                <i className="fa fa-download"></i>
              </div>

              <span className="download-text">TeamViewer</span>
            </div>

            <a
              href="https://filehippo.com/download_teamviewer/"
              target="_blank"
              rel="noreferrer"
              className="download-btn"
            >
              Download
            </a>
          </li>

          <li className="download-item">
            <div className="download-left">
              <div className="download-icon">
                <i className="fa fa-download"></i>
              </div>

              <span className="download-text">AnyDesk</span>
            </div>

            <a
              href="https://anydesk.com/platforms/windows"
              target="_blank"
              rel="noreferrer"
              className="download-btn"
            >
              Download
            </a>
          </li>

          <li className="download-item">
            <div className="download-left">
              <div className="download-icon">
                <i className="fa fa-file-archive"></i>
              </div>

              <span className="download-text">
                WinRAR 64 Bit (For Zip File)
              </span>
            </div>

            <a
              href="https://filehippo.com/download_winrar/64/"
              target="_blank"
              rel="noreferrer"
              className="download-btn"
            >
              Download
            </a>
          </li>

          <li className="download-item">
            <div className="download-left">
              <div className="download-icon">
                <i className="fa fa-file-archive"></i>
              </div>

              <span className="download-text">
                WinRAR 32 Bit (For Zip File)
              </span>
            </div>

            <a
              href="https://filehippo.com/download_winrar/"
              target="_blank"
              rel="noreferrer"
              className="download-btn"
            >
              Download
            </a>
          </li>
        </ul>
      </div>
    </div>
  );
}
